import { COMPONENTS_TYPES } from '@namespace/cms';
import ChangePassword from '../ChangePassword';
import HeaderContactInfoWithCustomChat from '../Header/components/HeaderContactInfoWithCustomChat';
import Language from '../Header/components/Language';
import PasswordRecovery from '../PasswordRecovery';
import ProfileData from '../PersonalOffice/ProfileData';
import ProfileDocuments from '../PersonalOffice/ProfileDocuments';
import Register from '../Register';

export const pageComponentsMap = {
  [COMPONENTS_TYPES.REGISTER]: Register,
  [COMPONENTS_TYPES.PROFILE_DATA]: ProfileData,
  [COMPONENTS_TYPES.PROFILE_READONLY_DOCUMENTS]: ProfileDocuments,
  [COMPONENTS_TYPES.PASSWORD_RECOVERY]: PasswordRecovery,
  [COMPONENTS_TYPES.LANGUAGE]: Language,
  [COMPONENTS_TYPES.HEADER_CONTACT_INFO_WITH_CUSTOM_CHAT]:
    HeaderContactInfoWithCustomChat,
  [COMPONENTS_TYPES.CHANGE_PASSWORD]: ChangePassword
};
